// components/BotsonicWidget.js

import Head from 'next/head';

const BotsonicWidget = () => {
  return (
    <Head>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,o,f,js,fjs){
              w["botsonic_widget"]=o;w[o]=w[o]||function(){
                (w[o].q=w[o].q||[]).push(arguments);
              };
              (js=d.createElement(s)),
              (fjs=d.getElementsByTagName(s)[0]);
              js.id=o;
              js.src=f;
              js.async=1;
              fjs.parentNode.insertBefore(js,fjs);
            })(window,document,"script","Botsonic","https://widget.writesonic.com/CDN/botsonic.min.js");
            Botsonic("init", {
              serviceBaseUrl: "https://api.botsonic.ai",
              token: "797fb1c6-ef5f-48cf-a3b9-86b08052ee1b",
            });
          `,
        }}
      />
    </Head>
  );
};

export default BotsonicWidget;